module.exports = __webpack_public_path__ + "fonts/EuclidFlex-Semibold.30356c6.otf";